import { DIRECT_DEBIT_PAYMENT_TYPES, INSTANT_PAYMENT_TYPE } from 'constants/shared-components';

export const isDirectDebitPaymentType = (paymentType: number): boolean => {
  return DIRECT_DEBIT_PAYMENT_TYPES.includes(paymentType);
};

export const isInstantPaymentType = (paymentType: number): boolean => {
  return paymentType === INSTANT_PAYMENT_TYPE;
};
